/*
 * @Author: wsx
 * @Date: 2022-01-05 11:10:59
 * @LastEditTime: 2022-01-05 14:37:04
 * @LastEditors: your name
 * @Description:
 */
export default [{
  path: "Home",
  name: "Home",
  component: () =>
    import ("@/views/Home.vue"),
  meta: {
    title: "首页"
  }
}];